export default {
  hello: 'Hello!',
  back: 'Back to search',
  card: {
    label: 'See details about the activity',
    infos: 'Activity\'s informations',
    favorite: 'Add to favorites',
    new: 'New activity',
    from: 'From ',
  },
  images: {
    gallery: 'Gallery',
    availabilities: 'View availabilities',
  },
  list: {
    label: 'Activities list',
    total: 'activities found',
    load: 'Load more',
  },
  menu: {
    sorting: 'Sort by',
    filters: 'Filters',
    relevance: 'Relevance',
    price_asc: 'Price asc. ',
    price_desc: 'Prix desc.',
    ranking: 'Ranking',
    place: 'Place',
    moment: 'Time of day',
    duration: 'Duration',
    price: 'Price',
    min: 'Min. price €',
    max: 'Max. price €',
    range: 'Available ',
    day: 'all day',
    from: 'from',
    to: 'to',
    start: 'Duration min:',
    end: 'Duration max:',
  },
  search: {
    label: 'Search for activities',
    button: 'Search',
    cancel_button: 'Delete all',
    placeholder: 'Search',
    themes: 'Themes',
    activities: 'Activities',
    default: 'Start searching',
    dates: 'All dates',
    togglethemes: 'See available themes',
    // toggleactivities: "See available activities",
    togglecalendar: 'Set a date range',
  },
  timeRange: {
    morning: 'In the morning (from 8 AM to noon)',
    afternoon: 'In the afternoon (from noon to 5 PM)',
    evening: 'In the evening (from 5 PM to midnight)',
  },
  activities: {
    label: 'Activities list',
    left: 'Slide to left',
    right: 'Slide to right',
  },
  editor: {
    selection: {
      manual: 'Manual selection',
      auto: 'Automatic selection',
      validate: 'Validate my selection',
      configure: 'Configure the selection',
      summary: 'Selection summary',
      from_any_provider: 'from any providers',
    },
    searchEngine: {
      title: 'YouBOOK Search Engine Widget',
    },
    title: 'YouBOOK Highlight Widget',
    create_widget: 'Create the widget',
    delete_all: 'Delete all',
    add_product: 'Add an activity',
    search_product: 'Search for a product ...',
    do_manual_selection: 'Make your manual selection',
    show_results: 'Show results',
  },
  filters: {
    places: 'Place | Places',
    types: 'Type | Types',
    themes: 'Theme | Themes',
    audiences: 'Audience | Audiences',
    internals: 'Internal | Internals',
  },
  providers: {
    regiondo: 'Regiondo',
    welogin: 'WeLogin',
    guidap: 'Guidap',
    bokun: 'Bókun',
  },
  aria: {
    details: 'Offer details',
    presentation: 'activity presentation',
    cta: 'book this activity now',
    cta_action: 'book a date',
    provider_logo: 'supplier logo',
    highlights: 'activity highlights',
    provider_book: 'booking with the supplier',
    crosselling: 'You might also like...',
  },
  cta: {
    share: 'Share',
    price: 'From',
    book: 'Book',
    book_a_date: 'Book a date',
    add_to_favorites: 'Add to favorites',
    retry: 'Retry',
    next_session: 'Next session',
  },
  popover: {
    share: 'Share this activity:',
    go_to: 'How to go ?',
  },
  content: {
    reviews: 'reviews',
    recommended_by: 'Recommended by',
    available_soon: 'Activity available soon',
    available_today: 'Available today',
    available_tomorrow: 'Available tomorrow',
    highlights: 'Highlights',
    options: 'Choose your dates, options ...',
    fee: 'Zero fee, same price as direct',
    experience: 'Your experience',
    included: 'Included',
    not_included: 'Not Included',
    powered_by: 'Offered By ',
    conditions: 'Conditions',
    essentials: 'Essentials',
    groups: 'Participants',
    other: 'Additional',
    meeting_point: 'Meeting point',
    go_to: 'Go to',
    address: 'Address:',
    how_to_go: 'How to get there:',
    transport: 'Transport:',
    book_peacefully: 'Book with peace of mind with our partner',
    complementary_infos: 'Complementary informations',
    locality: 'Locality',
    other_activities: 'You might also like...',
    eco_friendly: {
      title: 'Committed to Sustainability',
      description: 'By choosing the low-carbon activity \« {activityName} \», you significantly reduce your environmental impact.',
      detail: 'A low-carbon activity emits little to no CO2 from fossil fuels.',
    },
    more: 'See more',
    less: 'See less',
  },
  cart: {
    disclaimer: 'Réserver en toute sérénité avec notre partenaire technique.',
    article: '{count} article | {count} articles',
    empty: 'No cart in progress',
  },
  error: {
    data_unavailable: 'Data unavailable for now.',
  },
  map: {
    label: 'Map',
    cta: 'View on map',
    close: 'Close map',
    filters: 'Filter by',
    filter: 'Filter',
  },
};
